import solarSystem from '../data/solarSystem.js'
import dataSolarObject from '../data/dataSolarObject.js'

export default {
  solarSystem,
  dataSolarObject
}
